/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Search_CtaInputs */

const en_home_search_cta = /** @type {(inputs: Home_Search_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Search`)
};

/**
* | output |
* | --- |
* | "Search" |
*
* @param {Home_Search_CtaInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const home_search_cta = /** @type {((inputs?: Home_Search_CtaInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Search_CtaInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_home_search_cta(inputs)
});